<template>
  <div class="p-d-flex p-flex-column p-ai-center">
    <div class="p-mt-6 p-mb-5 text-title" id="titleImmat">
      <p>Renseignez l’immatriculation du véhicule ou la marque et son modèle.</p>
    </div>

    <small v-if="checkValidation" class="p-error">
      Veuillez renseigner les informations concernant votre véhicule
    </small>
    <div class="p-d-flex p-ai-center" style="width: 60%">
      <span class="p-input-icon-right input-zone first-input-zone" style="width: 100% !important;">
        <i
            v-if="appointmentStore.loading"
            class="pi pi-spin pi-spinner"
        />
        <i v-else @click="checkLicencePlate" class="pi pi-search"/>
        <InputText
            id="licensePlateInput"
            v-on:keydown.enter="blurAndSearch"
            type="text"
            v-model="licencePlate"
            placeholder="AH-123-DB"
            style="text-transform: uppercase"
        />
      </span>
      <i
         v-if="licencePlate"
         class="pi pi-times"
         @click="emptyData"
      />
    </div>
    <div v-if="licencePlateHasBeenRecognized" class="p-mt-6 p-mb-5 text-success">
      Bonne nouvelle ! Nous prenons en charge ce modèle.
    </div>

    <div v-if="errorWithLicencePlate" class="p-mt-6 p-mb-5">
      <div class="text-error">
        Immatriculation non-trouvée
      </div>
      <div>
        Vous ne trouvez pas votre véhicule ? Veuillez renseigner la marque et le modèle ci-dessous.
      </div>
    </div>

    <Image :src="useImage('visuel-immatriculation.png')" alt="Pare-brise" />
    <Dropdown
      v-if="!licencePlateHasBeenRecognized"
      filter
      v-model="brand"
      @change="fetchCarModel"
      :options="appointmentStore.brands"
      optionLabel="MARQUE_LIBELLE"
      placeholder="Marque du véhicule"
      class="input-zone"
    />
    <Dropdown
      filter
      v-model="car_model"
      :options="appointmentStore.car_models"
      optionLabel="MODELE_LIBELLE"
      placeholder="Modèle du véhicule"
      class="input-zone"
      v-if="brand !== null && brand.MARQUE_LIBELLE !== 'Autre'"
    />
    <InputText
      :readonly="licencePlateHasBeenRecognized"
      v-if="checkIfBrandOrModelNotFound || cannotLinkModelOrBranToLicensePlate"
      type="text"
      v-model="modelInput"
      placeholder="Votre modèle de véhicule"
      class="input-zone"
      :class="{ 'bold-font': cannotLinkModelOrBranToLicensePlate }"
    />
    <div class="p-d-inline-flex p-jc-center p-my-6" style="width: 60%">
      <div :class="{'p-mt-sm-3': true, 'p-mr-5': brand !== null && brand.MARQUE_LIBELLE !== 'Autre' && car_model !== null || modelInput !== null}">
        <Button class="button-navigate button-back" @click="onPrevious">Précédent</Button>
      </div>
      <div class="p-mt-sm-3" v-if="(brand !== null && brand.MARQUE_LIBELLE !== 'Autre' && car_model !== null) || modelInput !== null">
        <Button class="button-navigate" @click="onNext">Suivant</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref } from "vue";
import { useMenuStore } from "../stores/menu";
import { useAppointmentStore } from "../stores/appointment";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default {
  name: "StepCar",
  setup(props, { emit }) {
    const menuStore = useMenuStore();
    const appointmentStore = useAppointmentStore();
    const brand = ref(null);
    const car_model = ref(null);
    const licencePlate = ref(null);
    const modelInput = ref(null);
    const licencePlateHasBeenRecognized = ref(false)
    const errorWithLicencePlate = ref(false)
    const cannotLinkModelOrBranToLicensePlate = ref(false)

    const checkIfBrandOrModelNotFound = computed(() => {
      if (
        brand.value && brand.value.MARQUE_LIBELLE === "Autre" ||
        car_model.value && car_model.value.MODELE_LIBELLE === "Autre"
      ) {
        return true;
      } else {
        return false;
      }
    });

    const rules = {
      brand: { required },
    };

    const v$ = useVuelidate(rules, {
      brand,
    });

    const blurAndSearch = () => {
      document.getElementById('licensePlateInput').blur()
      checkLicencePlate()
    }

    const checkValidation = computed(() => {
      if (v$.value.$error) {
        return true;
      } else {
        return false;
      }
    });

    const emptyData = () => {
      brand.value = null
      car_model.value = null
      licencePlate.value = null
      modelInput.value = null
      licencePlateHasBeenRecognized.value = false
      errorWithLicencePlate.value = false
      cannotLinkModelOrBranToLicensePlate.value = false
      appointmentStore.appointment.numberplate = null
    };

    const onNext = () => {
      v$.value.$touch();
      if (!v$.value.$error) {
        const nextUrl = "/mes-coordonnees";
        const target = menuStore.getMenuItemWithUrl(nextUrl);
        target.parent = menuStore.currentMenuItem.to;
        if (licencePlate.value != null) {
          appointmentStore.appointment.numberplate = licencePlate.value;
        }
        if (modelInput.value && brand.value.MARQUE_LIBELLE !== "Autre") {
          appointmentStore.appointment.car_model_name = modelInput.value;
          appointmentStore.appointment.brand_name = brand.value.MARQUE_LIBELLE
          appointmentStore.appointment.brand_id = brand.value.ID_MARQUE;
        }
        else if (modelInput.value) {
          appointmentStore.appointment.car_model_name = modelInput.value;
        } else {
          appointmentStore.appointment.car_model_name = car_model.value.MODELE_LIBELLE;
          appointmentStore.appointment.brand_id = brand.value.ID_MARQUE;
          appointmentStore.appointment.car_model_id = car_model.value.ID_MODELE;
          appointmentStore.appointment.brand_name = brand.value.MARQUE_LIBELLE
          appointmentStore.other_information.brand_name = brand.value.MARQUE_LIBELLE;
        }

        let dataLayerToPush = {
          'event' : 'click',
          'pageName' : '/prise-de-rendez-vous/#/mon-vehicule',
          'eventCategory' : 'rdv',
          'eventAction' : 'next',
          'eventName' : nextUrl,
        };
        if (appointmentStore.appointment.numberplate) dataLayerToPush.numberplate = appointmentStore.appointment.numberplate;
        if (appointmentStore.appointment.car_model_name) dataLayerToPush.car_model_name = appointmentStore.appointment.car_model_name;
        if (appointmentStore.appointment.brand_id) dataLayerToPush.brand_id = appointmentStore.appointment.brand_id;
        if (appointmentStore.appointment.car_model_id) dataLayerToPush.car_model_id = appointmentStore.appointment.car_model_id;
        if (appointmentStore.appointment.brand_name) dataLayerToPush.brand_name = appointmentStore.appointment.brand_name;
        if (appointmentStore.other_information.brand_name) dataLayerToPush.other_brand_name = appointmentStore.other_information.brand_name;
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayerToPush);

        emit("nextPage", target);
      }
    };

    const onPrevious = () => {
      emit("prevPage", menuStore.currentMenuItem);
    };

    const useImage = (imageName) => {
      return require(`../assets/img/${imageName}`);
    };

    const fetchCarModel = async () => {
      await appointmentStore.fetchCarModels(brand.value.ID_MARQUE);
      appointmentStore.car_models.push({
        MODELE_LIBELLE: "Autre",
      });
    };

    const checkLicencePlate = async () => {
      licencePlateHasBeenRecognized.value = false;
      cannotLinkModelOrBranToLicensePlate.value = false;
      errorWithLicencePlate.value = false;
      appointmentStore.loading = true;
      appointmentStore.appointment.brand_id = null
      appointmentStore.appointment.car_model_id = null
      modelInput.value = null
      brand.value = null
      car_model.value = null
      if (licencePlate.value !== null) {
        licencePlate.value = licencePlate.value.toUpperCase();
        let res;
        try {
          res = await appointmentStore.fetchCarModelFromLicencePlate(
            licencePlate.value
          );
        } catch (e) {
          console.log(e);
        }
        if (res && res.brand_id && res.brand !== 'erreur') {
          appointmentStore.appointment.numberplate = licencePlate.value;
          const val = appointmentStore.brands.find(element => element.ID_MARQUE === res.brand_id)
          if (val) {
            brand.value = val;
            fetchCarModel();
          } else if (res.brand) {
            brand.value = appointmentStore.brands.find(element => element.MARQUE_LIBELLE === "Autre")
          }
          licencePlateHasBeenRecognized.value = true;
        } else if (res && res.brand  && res.brand !== 'erreur' && res.model && res.model !== 'erreur') {
          licencePlateHasBeenRecognized.value = true;
          cannotLinkModelOrBranToLicensePlate.value = true;
          modelInput.value = res.brand + ' ' + res.model;
          //dans le cas particulier où on a bien un libellé de marque et de modèle, mais que G1 n'a pas retourné ID_MARQUE, alors res.brand_id vaut 0
          //et pour ne pas bloquer ce cas, on force la marque à "Autre"...
          if (res.brand_id == 0) brand.value = appointmentStore.brands.find(element => element.MARQUE_LIBELLE === "Autre");
        } else {
          licencePlateHasBeenRecognized.value = false;
          errorWithLicencePlate.value = true;
          licencePlate.value = null;
          brand.value = null;
          car_model.value = null;
        }
        if (res.model_id) {
          const val = appointmentStore.car_models.find(element => element.ID_MODELE === res.model_id)
          if (val) {
            car_model.value = val;
            appointmentStore.appointment.car_model_id = res.model_id
          } else {
            car_model.value = appointmentStore.car_models.find(element => element.MODELE_LIBELLE === "Autre")
            licencePlateHasBeenRecognized.value = true;
            cannotLinkModelOrBranToLicensePlate.value = true;
            modelInput.value = res.brand + ' ' + res.model
            appointmentStore.appointment.brand_id = res.brand_id
            appointmentStore.appointment.car_model_id = res.model_id
          }
        } else if (res && res.brand  && res.brand !== 'erreur' && res.model && res.model !== 'erreur') {
          licencePlateHasBeenRecognized.value = true;
          cannotLinkModelOrBranToLicensePlate.value = true;
          modelInput.value = res.brand + ' ' + res.model
          if (res.brand_id) {
            appointmentStore.appointment.brand_id = res.brand_id
          }
        }
      }
      appointmentStore.loading = false;
    };

    return {
      onPrevious,
      onNext,
      useImage,
      brand,
      car_model,
      licencePlate,
      appointmentStore,
      fetchCarModel,
      checkLicencePlate,
      modelInput,
      checkIfBrandOrModelNotFound,
      checkValidation,
      licencePlateHasBeenRecognized,
      errorWithLicencePlate,
      cannotLinkModelOrBranToLicensePlate,
      emptyData,
      blurAndSearch
    };
  },
  async mounted() {
    const appointmentStore = useAppointmentStore();
    await appointmentStore.fetchBrands();
    appointmentStore.brands.push({
      MARQUE_LIBELLE: "Autre",
    });
    if (window.matchMedia("(max-width: 811px)").matches) {
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.srcElement.localName === 'input') {
          e.srcElement.blur()
        }
      })
    }
  },
};
</script>

<style scoped>
.bold-font {
  font-weight: bold;
}
.input-zone {
  width: 60% !important;
  text-align: center;
  margin: 5px 0px !important;
}
.first-input-zone {
  margin-bottom: 15px !important;
}
.pi {
  color: #24a285 !important;
  font-size: 1.5em !important;
  font-weight: bold;
}
.pi-search {
  cursor: pointer !important;
  z-index: 100;
  margin-top: -.75rem;
}
.pi-times {
  cursor: pointer !important;
  z-index: 100;
  margin-top: -.5rem !important;
  margin-left: .25rem !important;
}
.p-dropdown { /* force border of dropdown to show */
  border: 1px solid #a6a6a6 !important;
}

@media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
  .input-zone {
    width: 100% !important;
  }
}
</style>
